import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M1.5 15V12M1.5 9V12M1.5 12H5.5M5.5 12V9M5.5 12V15M6.75 9.75H9M11.25 9.75H9M9 9.75V15M19.5 9V14.25H22.5M12.5 15V9.75H12.75L14.5 12H15L16.75 9.75H17V15" vectorEffect="non-scaling-stroke" />
	</SVG>
);
